
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    const route = useRoute()
    const internalInstance = getCurrentInstance()
    const refFrmReset: any = ref(null)
    const message = reactive({
      msg: '',
      err: false
    })
    const frmReset = reactive({
      password: '',
      checkPass: ''
    })
    const validatePass2 = (rule: any, value: string, callback: any) => {
        if(value === '') {
          callback(new Error('確認用パスワードを入力してください。'));
        }else if(value !== frmReset.password) {
          callback(new Error('2回入力されたパスワードが一致しません。'));
        }else {
          callback();
        }
    }
    const rules = {
      password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
        { min: 8, message: '8文字以上必要です。', trigger: 'blur' }
      ],
      checkPass: [
        { validator: validatePass2, trigger: 'blur' }
      ]
    }
    const submitForm = () => {
      refFrmReset.value.validate((valid: boolean) => {
        if(valid) {
          const api_path = internalInstance?.appContext.config.globalProperties.api_path
          fetch(api_path + 'ajax/pwreset.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'password': frmReset.password,
              'email': route.query.id,
              'token': route.query.token
            })
          })
          .then(response => response.json())
          .then(json => {
            //console.log(json);
            if(json['result'] == 'failure') {
              throw new Error(json.error)
            }
            message.msg = "リセットしました。";
            message.err = false;
          })
          .catch(error => {
            console.error(error)
            message.err = true
            message.msg = error.message
          })
        }
      })
    }

    return {
      message,
      frmReset,
      refFrmReset,
      submitForm,
      rules,
    }
  }
})
